<template>
  <div class="devicebelonglist">
    <div class="section">
      <div class="tablemain tableloding">
        <!-- @selection-change="changeFun" -->
        <!-- height="100%" -->
        <el-table :data="deviceList" border stripe :row-style="{ height: 0 }" :cell-style="{ padding: 0 }"
          :header-cell-style="{ background: 'rgb(65, 80, 90)', color: '#ffffff' }" v-loading="loadingdevice"
          element-loading-spinner="el-icon-loading">
          <!-- :empty-text="$t('message.nodata')" -->
          <!-- <el-table-column fixed type="selection"></el-table-column> -->
          <el-table-column fixed prop="devalias" min-width="185px;" :label="$t('device.device_name')"
            :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span class="redirect" @click="enterDevice(scope.row)"
                :title="scope.row.devalias || scope.row.sn">{{ scope.row.devalias || scope.row.sn }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="sn" min-width="185px;" :label="$t('device.device_sn')"
            :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span :title="scope.row.deviceSn||scope.row.sn || '--'">{{ scope.row.deviceSn || scope.row.sn || '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="status" min-width="120px;" :label="$t('device.device_status')"
            :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span v-if="scope.row.status !== undefined"
                :class="`color-${$filter.deviceStatus[scope.row.status].name}`">{{ $filter.deviceStatus[scope.row.status].label }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="brand" min-width="115px;" :label="$t('device.device_type')"
            :show-overflow-tooltip="true">
            <template slot-scope="scope">{{ scope.row.brand | translateDeviceType }}</template>
          </el-table-column>
          <el-table-column width="90px;" prop="devcode" :label="$t('device.device_code')"
            :show-overflow-tooltip="true"></el-table-column>
          <!-- <el-table-column
            prop="pn"
                        min-width="140px;"
            :label="$t('device.datalogger_pn')"
            :show-overflow-tooltip="true"
          ></el-table-column> -->
          <el-table-column prop="devaddr" min-width="135px;" :label="$t('device.device_address')"
            :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="profitToday" min-width="120px;" :label="$t('device.Today_income')"
            :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ scope.row.profitToday | formatNum(2) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="profitTotal" min-width="150px;" :label="$t('device.Cumulative_income')"
            :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ scope.row.profitTotal | formatNum(2) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="sellProfitToday" min-width="150px;" :label="$t('device.sellProfit_Today')"
            :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ scope.row.sellProfitToday | formatNum(2) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="sellProfitTotal" min-width="150px;" :label="$t('device.sellProfit_Total')"
            :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ scope.row.sellProfitTotal | formatNum(2) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="buyProfitToday" min-width="150px;" :label="$t('device.buyProfit_Today')"
            :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ scope.row.buyProfitToday | formatNum(2) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="buyProfitTotal" min-width="150px;" :label="$t('device.buyProfit_Total')"
            :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ scope.row.buyProfitTotal | formatNum(2) }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column
                      prop="collalias"
            min-width="140px;"
            :label="$t('device.coll_alias')"
            :show-overflow-tooltip="true"
                      ></el-table-column> -->
          <el-table-column width="115px;" :label="$t('device.device_model')" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span :title="scope.row.devtype || '--'">{{ scope.row.devtype || '--' }}</span>
            </template>
          </el-table-column>
          <div v-show="emptyText" slot="empty">
            <img src="@/assets/img/empty_text.png" />
            <div style="line-height: 32px">{{ $t('account.nodata') }}</div>
          </div>
        </el-table>
      </div>
      <div class="tablebottom">
        <!-- v-show="paginationControl" -->
        <el-pagination v-show="paginationControl" class="pagination" background @size-change="getDeviceList(true)"
          @current-change="() => getDeviceList()" :current-page.sync="pagination.currentPage"
          :page-sizes="[10, 15, 20, 30, 50]" :page-size.sync="pagination.pagesize"
          layout="slot, sizes, total, pager, prev, next" :total="pagination.total" popper-class="select-page-recharge">
          <span style="color:#ffffff;padding-left:15px;">{{ $t('device.pageSize') }} :</span>
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      noDataControl: false,
      emptyText: false,
      paginationControl: false,
      progressUp: false,
      progress: 0,
      search: {
        status: "",
        brand: "",
        pn: "",
        search: ""
      },
      xieyi: [],
      file: null, //保存上传文件流的容器
      progerssComplete: false,
      uploadNowSize: "0.00", //现在正在上传的大小
      uploadTotalSize: "", //文件的总大小
      firmwareName: "",
      paramass: "", //中间变量
      searchrechargeContents: "", //选择固件时里面的内容
      searchrecharge: {
        firmware: "",
        firmwaretype: "0",
        brate: "0"
      },
      dataparams: "",
      rechargelist: [],
      firmwaretypelist: [
        {
          //通用固件
          id: 11,
          label: this.$t("device.universal_firmware"),
          value: "0"
        },
        {
          //通讯版固件
          id: 12,
          label: this.$t("device.communication_firmware"),
          value: "1"
        },
        {
          //控制版固件1
          id: 13,
          label: this.$t("device.control_firmware1"),
          value: "2"
        },
        {
          //控制版固件2
          id: 14,
          label: this.$t("device.control_firmware2"),
          value: "3"
        },
        {
          //BMS固件
          id: 15,
          label: this.$t("device.control_firmware_bms"),
          value: "4"
        },
        {
          //SlavMCU固件
          id: 16,
          label: this.$t("device.control_firmware_slavmcu"),
          value: "5"
        }
      ],
      bratelist: [
        {
          //默认
          label: this.$t("device.default"),
          value: "0"
        },
        {
          label: 1200,
          value: "1200"
        },
        {
          label: 2400,
          value: "2400"
        },
        {
          label: 4800,
          value: "4800"
        },
        {
          label: 9600,
          value: "9600"
        },
        {
          label: 19200,
          value: "19200"
        },
        {
          label: 38400,
          value: "38400"
        },
        {
          label: 57600,
          value: "57600"
        },
        {
          label: 115200,
          value: "115200"
        }
      ],
      loadingdevice: false,
      pagination: {
        currentPage: 1,
        pagesize: 15,
        total: 0
      }, //分页数据
      deviceList: [],

      //   selectedAlarm: [], //批量删除
      //   tableDataBse:[],
      //   tableDataStd:[],
      //   tableDataSvs:[],
      //   tableDataPvs:[],
      //   tableDataGrd:[],
      //   tableDataBat:[],
      //   tableDataCts:[],
      //   tableDataLos:[],
      //   tableDataElse:[],
      //   tableDataHuangJinTai:[],//黄金台定制
      //   controlinter: [],
      //   controlvalue: "",
      //   editDeviceVisible: false,
      //   editDeviceInfo: null,
      //   debugDeviceVisible: false,
      //   debugDeviceId: null,
      //   upgradeDeviceVisible: false,
      //   upgradeDeviceterId: null,
      //   deletingDeviceInfo: null,
      //   controlDeviceVisible: false,
      //   statisticDialogVisible: false, //统计弹窗是否可见
      //   formEdit: {
      //     sn: "",
      //     pn: "",
      //     devaddr: "",
      //     devcode: "",
      //     alias: ""
      //   },
      //   device: {
      //     pn: ""
      //   },
      //   devDebug: {
      //     cmd: ""
      //   },
      //   debugReturn: ""
    };
  },
  watch: {
    // deleteDeviceVisible(val) {
    //   if (!val) this.deletingDeviceInfo = null;
    // },
    upgradeDeviceVisible(val) {
      if (!val) {
        clearInterval(this.interval);
        this.interval = null;
        this.progressUp = false;
      }
    },
    deviceInfo() {
      this.getDeviceList();
    },
  },
  computed: {
    ...mapGetters({
      deviceInfo: 'getDeviceInfo'
    })
  },
  created() {
    this.getDeviceList();
  },
  methods: {
    progressText(progress) {
      return progress === 100 ? this.$t("datalogger.finish") : `${progress}%`;
    },
    // 查看数采器对应设备
    getDeviceList(reset) {
      this.paginationControl = false;
      if (reset) this.pagination.currentPage = 1;
      let param = {
        // ...this.search,
        pn: this.deviceInfo.pn,
        devtype: 2304,
        page: this.pagination.currentPage,
        pageSize: this.pagination.pagesize
      };
      this.loadingdevice = true;
      this.$request.getMicroserDess("/dev/api/auth/valueCloud/dev/listTDeviceInfo", param).then(res => {
        if (res.code == 0) {
          // 新接口返回值转换为旧接口设备列表结构
          this.deviceList = this.Fnreturndev(res);
          this.pagination.total = res.data.total;
          if (this.pagination.total > this.pagination.pagesize) {
            this.paginationControl = true;
          }
        } else {
          // this.$message.warning(this.$t(`errCode.${res.err}`));
          this.emptyText = true;
          this.deviceList = [];
          this.pagination.total = 0;
        }
        this.loadingdevice = false;
      });
    },
    // 点击进入设备
    enterDevice(info) {
      this.$store.commit("saveDeviceInfo", {
        pn: info.pn,
        sn: info.sn,
        deviceSn: info.deviceSn || info.sn,
        devcode: info.devcode,
        devaddr: info.devaddr,
        profitToday: info.profitToday,
        profitTotal: info.profitTotal,
        sellProfitToday: info.sellProfitToday,
        sellProfitTotal: info.sellProfitTotal,
        buyProfitToday: info.buyProfitToday,
        buyProfitTotal: info.buyProfitTotal,
        otaLabel: info.otaLabel,
        devalias: info.devalias
      });
    },
  }
};
</script>
<style lang="less" scoped>
@import url("../../../../assets/css/mixin.less");

.devicebelonglist {
  display: flex;
  flex: 1;
  flex-direction: column;
  // margin: 20px;
  overflow: auto;
  // background-color: rgb(34, 45, 53);
  height: 548px;

  // 重定向
  .redirect {
    color: rgb(51, 255, 182);
    cursor: pointer;
  }

  .section {
    display: flex;
    flex: 1;
    padding: 0px;
    flex-direction: column;
    border-radius: 0px;
    border: none;
    background: rgb(34, 45, 53);
    position: relative;

    /deep/.el-icon-loading {
      font-size: 28px;
    }

    // .search {}
    .tableloding {

      // 加载数据时遮罩
      /deep/.el-loading-mask {
        background-color: rgb(34, 45, 53, .5);
      }

      /deep/.el-loading-spinner i {
        color: @primaryTextColor;
      }
    }

    .tablemain {
      border: none;
      background-color: rgb(34, 45, 53);

      .operation i {
        color: @primaryTextColor;
      }

      // /deep/.el-table tr {
      //   border-right: 1px solid rgba(198, 209, 221, 0.5);
      // }
      /deep/.el-table--border,
      /deep/.el-table--group {
        border: none;
        // border: 1px solid rgba(198, 209, 221, 0.5);
      }

      /deep/.el-table--border::after,
      /deep/.el-table--group::after {
        width: 0px;
      }

      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner {
        width: 16px;
        height: 16px;
        background: transparent;
        border: 1px solid rgb(180, 184, 193);
        border-radius: 0px;
      }

      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner::after {
        top: 2px;
        left: 5px;
      }

      /deep/.el-table__header th {
        height: 48px;
        border-right: 1px solid rgb(180, 184, 193);
      }

      /deep/.el-table__header th.is-leaf {
        border-color: rgba(198, 209, 221, 0.5);
        border-bottom: none;
      }

      /deep/.el-table__header th>.cell {
        font-weight: normal;
        font-size: 12px;
      }

      /deep/.el-table__body tr,
      /deep/.el-table__body td {
        background-color: rgb(34, 45, 53);
        color: #ffffff;
        border-color: rgba(198, 209, 221, 0.5);
        border-bottom: 1px solid rgba(198, 209, 221, 0.5);
      }

      /deep/.el-table__body td.el-table-column--selection {
        background-color: rgb(65, 80, 90);
        color: #ffffff;
      }

      /deep/.el-table__body .cell.el-tooltip {
        font-size: 14px;
      }

      /deep/.el-table__fixed-right::before,
      /deep/.el-table__fixed::before {
        display: none;
      }

      /deep/.el-table__body-wrapper {
        background: rgb(34, 45, 53);
      }

      /deep/.el-table--scrollable-x .el-table__body-wrapper {
        background: rgb(34, 45, 53);
      }

      ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background-color: #222d35;
      }
    }

    .tablebottom {
      // text-align:center;
      display: flex;
      justify-content: space-between;
      // margin-bottom: 10px;
      // border-top: 1px solid rgba(198, 209, 221, 0.5);
      border: none;

      // 分页
      .pagination {
        line-height: 48px;
        height: 48px;
        // align-self: flex-start;
        padding: 0;
        margin: 0;
        // margin-top: 20px;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        /deep/.el-pager li {
          vertical-align: middle;
        }

        /deep/.el-select .el-input {
          width: 90px;
          margin: 0px;
        }

        /deep/.el-input .el-input__inner {
          background-color: #202D35;
          color: #ffffff;
          border: none;
        }

        /deep/.el-input__suffix {
          right: 10px;
        }

        /deep/.el-pagination__sizes {
          margin: 0px;
        }

        /deep/.el-pagination__total {
          color: #fff;
          padding-left: 15px;
          border-left: 1px solid #7B8395;
        }

        /deep/.el-pager li:not(.disabled).active {
          background: #15C491;
          color: #ffffff;
        }

        /deep/.el-pager li:not(.disabled):not(.active):hover {
          color: #15C491;
        }

        /deep/.el-pager li {
          background-color: #2B3842;
          color: #7B8395;
        }

        // /deep/.el-pagination button:disabled {
        //   background-color: #2B3842;
        //   color: #7B8395;
        // }
        // /deep/.el-pagination button, 
        // /deep/.el-pagination span:not([class*=suffix]) {
        //   height: 48px;
        //   line-height: 48px;
        // }
      }

      // 分页前后按钮
      /deep/.el-pagination.is-background .btn-next,
      /deep/.el-pagination.is-background .btn-prev {
        background-color: #2B3842;
        color: #7B8395;
      }

      /deep/.el-pagination.is-background .btn-next:hover,
      /deep/.el-pagination.is-background .btn-prev:hover {
        color: #15C491;
      }

      /deep/.el-pagination.is-background button[disabled],
      /deep/.el-pagination.is-background button[disabled]:hover {
        color: #7B8395;
      }
    }
  }

  ::-webkit-scrollbar {
    width: 0px;
    height: 0px;
    background-color: #222d35;
  }
}
</style>